{
  "Audio Player": "Audio-Player",
  "Video Player": "Video-Player",
  "Play": "Abspielen",
  "Pause": "Pause",
  "Replay": "Erneut abspielen",
  "Current Time": "Aktueller Zeitpunkt",
  "Duration": "Dauer",
  "Remaining Time": "Verbleibende Zeit",
  "Stream Type": "Streamtyp",
  "LIVE": "LIVE",
  "Loaded": "Geladen",
  "Progress": "Status",
  "Progress Bar": "Forschrittsbalken",
  "progress bar timing: currentTime={1} duration={2}": "{1} von {2}",
  "Fullscreen": "Vollbild",
  "Non-Fullscreen": "Kein Vollbild",
  "Mute": "Ton aus",
  "Unmute": "Ton ein",
  "Playback Rate": "Wiedergabegeschwindigkeit",
  "Subtitles": "Untertitel",
  "subtitles off": "Untertitel aus",
  "Captions": "Untertitel",
  "captions off": "Untertitel aus",
  "Chapters": "Kapitel",
  "Descriptions": "Beschreibungen",
  "descriptions off": "Beschreibungen aus",
  "Audio Track": "Tonspur",
  "Volume Level": "Lautstärkestufe",
  "You aborted the media playback": "Sie haben die Videowiedergabe abgebrochen.",
  "A network error caused the media download to fail part-way.": "Der Videodownload ist aufgrund eines Netzwerkfehlers fehlgeschlagen.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Das Video konnte nicht geladen werden, da entweder ein Server- oder Netzwerkfehler auftrat oder das Format nicht unterstützt wird.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "Die Videowiedergabe wurde entweder wegen eines Problems mit einem beschädigten Video oder wegen verwendeten Funktionen, die vom Browser nicht unterstützt werden, abgebrochen.",
  "No compatible source was found for this media.": "Für dieses Video wurde keine kompatible Quelle gefunden.",
  "The media is encrypted and we do not have the keys to decrypt it.": "Die Entschlüsselungsschlüssel für den verschlüsselten Medieninhalt sind nicht verfügbar.",
  "Play Video": "Video abspielen",
  "Close": "Schließen",
  "Close Modal Dialog": "Modales Fenster schließen",
  "Modal Window": "Modales Fenster",
  "This is a modal window": "Dies ist ein modales Fenster",
  "This modal can be closed by pressing the Escape key or activating the close button.": "Durch Drücken der Esc-Taste bzw. Betätigung der Schaltfläche \"Schließen\" wird dieses modale Fenster geschlossen.",
  ", opens captions settings dialog": ", öffnet Einstellungen für Untertitel",
  ", opens subtitles settings dialog": ", öffnet Einstellungen für Untertitel",
  ", opens descriptions settings dialog": ", öffnet Einstellungen für Beschreibungen",
  ", selected": ", ausgewählt",
  "captions settings": "Untertiteleinstellungen",
  "subtitles settings": "Untertiteleinstellungen",
  "descriptions settings": "Einstellungen für Beschreibungen",
  "Text": "Schrift",
  "White": "Weiß",
  "Black": "Schwarz",
  "Red": "Rot",
  "Green": "Grün",
  "Blue": "Blau",
  "Yellow": "Gelb",
  "Magenta": "Magenta",
  "Cyan": "Türkis",
  "Background": "Hintergrund",
  "Window": "Fenster",
  "Transparent": "Durchsichtig",
  "Semi-Transparent": "Halbdurchsichtig",
  "Opaque": "Undurchsichtig",
  "Font Size": "Schriftgröße",
  "Text Edge Style": "Textkantenstil",
  "None": "Kein",
  "Raised": "Erhoben",
  "Depressed": "Gedrückt",
  "Uniform": "Gleichmässig",
  "Dropshadow": "Schlagschatten",
  "Font Family": "Schriftfamilie",
  "Proportional Sans-Serif": "Serifenlos proportional",
  "Monospace Sans-Serif": "Serifenlos nichtproportional",
  "Proportional Serif": "Serifiert proportional",
  "Monospace Serif": "Serifiert nichtproportional",
  "Casual": "Zwanglos",
  "Script": "Schreibeschrift",
  "Small Caps": "Small-Caps",
  "Reset": "Zurücksetzen",
  "restore all settings to the default values": "Alle Einstellungen auf die Standardwerte zurücksetzen",
  "Done": "Fertig",
  "Caption Settings Dialog": "Einstellungsdialog für Untertitel",
  "Beginning of dialog window. Escape will cancel and close the window.": "Anfang des Dialogfensters. Esc bricht ab und schließt das Fenster.",
  "End of dialog window.": "Ende des Dialogfensters.",
  "ISO-639-1": "de",
  "10 seconds backward": "10 Sekunden zurück",
  "30 seconds forward": " 30 Sekunden vorwärts",
  "Audio": "Tonspur",
  "Audio and subtitles": "Tonspur und Untertitel",
  "Audio Description": "Audiodeskription",
  "Auto play": "Autoplay",
  "Back": "Zurück",
  "Casting to": "Der Inhalt wird abgespielt auf",
  "Content will be available in {1} days": "Verfügbar in {1} Tagen",
  "Current position": "Aktuelle Position",
  "Current subject": "Aktueller Beitrag",
  "Days": "Tagen",
  "Duration: {1}": "Dauer: {1}",
  "Edit player settings": "Einstellungen bearbeiten",
  "Episode": "Ganze Folge",
  "HD": "HD",
  "Continuous Playback": "Fortlaufende Wiedergabe",
  "Cancel": "Abbrechen",
  "Coming next": "Nächstes Video",
  "Copied": "Kopiert",
  "copy": "kopieren",
  "Copy debug info": "Debug-Info kopieren",
  "Copy link": "Link kopieren",
  "Facebook": "Facebook",
  "Font size level {1}": "Schriftgrösse {1}",
  "Hours": "Stunden",
  "Integrate": "Integrieren",
  "Issue:": "technisches Problem:",
  "LinkedIn": "LinkedIn",
  "Mail": "E-Mail",
  "Minutes": "Minuten",
  "Off": "Aus",
  "Open {1} in Play {2}": "Dieses {1} in Play {2} öffnen",
  "Playback will begin shortly": "Die Wiedergabe beginnt in Kürze.",
  "Please indicate the problem below, so that we can help you:": "Bitte geben Sie das Problem unten an, damit wir Ihnen helfen können :",
  "Quality": "Qualität",
  "Report a technical problem": "Technisches Problem melden",
  "SD": "SD",
  "Seconds": "Sekunden",
  "Seek to live, currently behind live": "Zur Live-Übertragung wechseln. Aktuell wird es nicht live abgespielt.",
  "Seek to live, currently playing live": "Zur Live-Übertragung wechseln. Es wird aktuell live abgespielt.",
  "Send bug report": "Fehlerbericht senden",
  "Share at current position": "Teilen der aktuelle Position",
  "Share by e-mail": "Via E-Mail teilen",
  "Share": "Teilen",
  "Share on {1}": "Auf {1} teilen",
  "Share on Facebook": "Auf Facebook teilen",
  "Share on Linkedin": "Auf Linkedin teilen",
  "Share on Twitter": "Auf Twitter teilen",
  "Share on Whatsapp": "Auf Whatsapp teilen",
  "Share on X": "Auf X teilen",
  "Share the current subject": "Teilen des aktuellen Beitrags",
  "Share the episode": "Teilen der ganzen Folge",
  "Skip credits": "Abspann überspringen",
  "Skip intro": "Intro überspringen",
  "Speed": "Abspielgeschwindigkeit",
  "Start casting": "Über Chromecast abspielen",
  "Start pip": "Video im Pop-up öffnen",
  "Stop": "Anhalten",
  "Stop casting": "Abspielen über Chromecast abbrechen",
  "Stop pip": "Pop-up schliessen",
  "The content cannot be played.": "Der Inhalt kann nicht abgespielt werden.",
  "This content cannot be played while using a VPN.": "Dieser Inhalt ist mit aktiviertem VPN nicht abspielbar.",
  "The content was skipped due to legal restriction": "Der Inhalt wurde aus rechtlichen Gründen übersprungen.",
  "This content is temporarily unavailable for journalistic reasons.": "Dieser Inhalt steht aus publizistischen Gründen vorübergehend nicht zur Verfügung.",
  "This commercial media is not available.": "Die Werbung wurde übersprungen.",
  "This content is not available.": "Dieser Inhalt ist nicht verfügbar.",
  "This content is not available anymore.": "Dieser Inhalt ist nicht mehr verfügbar.",
  "This content is not available due to legal restrictions.": "Dieser Inhalt ist aus rechtlichen Gründen nicht verfügbar.",
  "This content is not available outside Switzerland.": "Dieser Inhalt ist ausserhalb der Schweiz nicht verfügbar.",
  "This content is not yet available. Please try again later.": "Dieser Inhalt ist noch nicht verfügbar. Bitte probieren Sie es später noch einmal.",
  "To protect children, this content is only available between 8PM and 6AM.": "Aus Gründen des Jugendschutzes steht dieser Inhalt nur zwischen 20:00 und 06:00 Uhr zur Verfügung.",
  "To protect children, this content is only available between 11PM and 5AM.": "Aus Gründen des Jugendschutzes steht dieser Inhalt nur zwischen 23:00 und 05:00 Uhr zur Verfügung.",
  "Twitter": "Twitter",
  "Unable to display the content. For more information and help, click here...": "Leider kann der Inhalt nicht wiedergegeben werden. Weitere Informationen und Unterstützung finden Sie hier…",
  "Unfortunately the 360 playback experience is not compatible with your browser version.": "Ihre Browser-Version ist nicht kompatibel für die 360°-Wiedergabe dieses Videos.",
  "Unfortunately this format is not compatible with your browser.": "Dieses Format ist leider nicht kompatibel mit Ihrem Browser.",
  "WhatsApp": "WhatsApp",
  "X": "X"
}
